export default path => {
  return {
    component: 'v-jd-tags',
    model: [path]
  }
}
